/** Countries whose Spanish uses voseo on the printed steps ("Escaneá / Pedí / Disfrutá"). */
export const MENU_QR_VOSEO_COUNTRIES: ReadonlySet<string> = new Set([
  'AR',
  'UY',
]);

export interface IMenuQrStepsCopy {
  scan: string;
  order: string;
  enjoy: string;
}

export interface IMenuQrCopy {
  locale: string;
  voseo: boolean;
  steps: IMenuQrStepsCopy;
  genericTitle: string;
  takeAwayTitle: string;
}

export type TMenuQrTranslate = (key: string) => string;

/** The admin locale matching the menu language (`pt-BR` → `pt`), or null when the admin has none. */
export function resolveMenuQrMenuLocale(
  menuLanguageId: string | null | undefined,
  supportedLocales: readonly string[]
): string | null {
  const base = (menuLanguageId ?? '').toLowerCase().split('-')[0];

  return base && supportedLocales.includes(base) ? base : null;
}

/**
 * Poster copy is diner-facing, so it follows the menu language when the admin
 * has translations for it; otherwise the operator's UI locale is used.
 */
export function resolveMenuQrCopyLocale(
  menuLanguageId: string | null | undefined,
  uiLocale: string,
  supportedLocales: readonly string[]
): string {
  return resolveMenuQrMenuLocale(menuLanguageId, supportedLocales) ?? uiLocale;
}

export function usesMenuQrVoseo(
  locale: string,
  country: string | null | undefined
): boolean {
  return (
    locale === 'es' &&
    MENU_QR_VOSEO_COUNTRIES.has((country ?? '').toUpperCase())
  );
}

export function buildMenuQrCopy(
  t: TMenuQrTranslate,
  locale: string,
  voseo: boolean
): IMenuQrCopy {
  const suffix = voseo ? '.voseo' : '';

  return {
    locale,
    voseo,
    steps: {
      scan: t(`qr.steps.scan${suffix}`),
      order: t(`qr.steps.order${suffix}`),
      enjoy: t(`qr.steps.enjoy${suffix}`),
    },
    genericTitle: t('qr.stickerTitle.generic'),
    takeAwayTitle: t(`qr.stickerTitle.takeaway${suffix}`),
  };
}
